export default "/_next/static/images/joseph-schricker-06adce8ac90f411af9c4a8b7c29e763b.png";